// @flow

import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { Link } from 'react-router-dom';
import { handleTagEvent }from 'utils/tagManagerUtils';
import type { FullUserType } from 'types/User';

export type StateProps = {
  userPref: FullUserType
};

type Props = StateProps & {
  url: string,
  title: string,
  linkLabel: string,
  desc?: string,
};

class CardSimple extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    url: '#',
    isCompact: false,
    title: 'Bulletins officiels',
    linkLabel: 'En savoir plus'
  };

  render() {
    const { userPref, url, title, desc, linkLabel } = this.props;
    const classNamesCard = dynamicClassName('box box--white card card--simple card--large mb-5 mb-md-7 mb-lg-8');

    return (
      <Link
        to={url}
        className={classNamesCard.build()}
        onClick={handleTagEvent(
          'module contenu',
          title,
          window.location.pathname,
          userPref
        )}>
        <div className="card__body">
          <h3 className="card__title">{title}</h3>
          {desc && <p className="card__desc mb-0">{desc}</p>}
        </div>
        <div className="card__footer">
          <span className="link-chevron">
            {linkLabel}
            <i className="icon icon-chevron-right" />
          </span>
        </div>
      </Link>
    );
  }
}

export default CardSimple;
